import { render, staticRenderFns } from "./SitemapPage.vue?vue&type=template&id=39a91a96&scoped=true&"
import script from "./SitemapPage.vue?vue&type=script&lang=js&"
export * from "./SitemapPage.vue?vue&type=script&lang=js&"
import style0 from "./SitemapPage.vue?vue&type=style&index=0&id=39a91a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a91a96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a91a96')) {
      api.createRecord('39a91a96', component.options)
    } else {
      api.reload('39a91a96', component.options)
    }
    module.hot.accept("./SitemapPage.vue?vue&type=template&id=39a91a96&scoped=true&", function () {
      api.rerender('39a91a96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sitemap/SitemapPage.vue"
export default component.exports